import { useEffect, useState } from "react";

import EditOrCreateProjectLightbox from "../lightboxes/projects/EditOrCreateProjectLightbox";
import { OutlinedDropdownMenu } from "../common/DropdownMenu";
import { EProjectStatus, IProject } from "../../data_models/project";

import { ProjectCard } from "../../pages/MyProjectsPage";
import useRouting from "../../hooks/useRouting";
import useProjects from "../../hooks/useProjects";



const EmployerMyProjects = () => {

    const filterOptions = [
        'All',
        'Drafts',
        'Ongoing',
        'Completed',
    ]

    const sortOptions = [
        'Newest First',
        'Oldest First',
        'Status (A-Z)',
        'Status (Z-A)',
        'Project Title (A-Z)',
        'Project Title (Z-A)',
    ]

    const [showCreateProjectLightbox, setShowCreateProjectLightbox] = useState(false);
    const { fetchMyProjects } = useProjects();
    const { goToProjectDetails } = useRouting();

    const [activeFilter, setActiveFilter] = useState(filterOptions[0]);
    const [activeSort, setActiveSort] = useState(sortOptions[0]);
    const [allProjects, setAllProjects] = useState<IProject[]>([]);
    const [projects, setProjects] = useState<IProject[]>([]);

    useEffect(() => {
        const fetchProjects = async () => {
            const projects = await fetchMyProjects(1, 99999);
            setAllProjects(projects);
        }
        fetchProjects();
    }, []);

    useEffect(() => {
        getFilteredProjects();
    }, [
        activeFilter,
        activeSort,
        allProjects,
    ]);

    const getFilteredProjects = () => {
        const filteredProjects: IProject[] = [];
        if (activeFilter === 'All') {
            filteredProjects.push(
                ...allProjects,
            );
        } else if (activeFilter === 'Drafts') {
            filteredProjects.push(...allProjects.filter(project => project.status === EProjectStatus.DRAFT));
        } else if (activeFilter === 'Ongoing') {
            filteredProjects.push(
                ...allProjects.filter(project => (project.status || Infinity) < EProjectStatus.COMPLETED
                    && (project.status || 0) > EProjectStatus.DRAFT)
            );
        } else if (activeFilter === 'Completed') {
            filteredProjects.push(
                ...allProjects.filter(project => project.status === EProjectStatus.COMPLETED),
            );
        }

        // Apply sorting
        const sortedProjects = [...filteredProjects];
        switch (activeSort) {
            case 'Newest First':
                sortedProjects.sort((a, b) => {
                    const dateA = a._createdAt ? new Date(a._createdAt).getTime() : 0;
                    const dateB = b._createdAt ? new Date(b._createdAt).getTime() : 0;
                    return dateB - dateA;
                });
                break;
            case 'Oldest First':
                sortedProjects.sort((a, b) => {
                    const dateA = a._createdAt ? new Date(a._createdAt).getTime() : 0;
                    const dateB = b._createdAt ? new Date(b._createdAt).getTime() : 0;
                    return dateA - dateB;
                });
                break;
            case 'Status (A-Z)':
                sortedProjects.sort((a, b) => (a.status || 0) - (b.status || 0));
                break;
            case 'Status (Z-A)':
                sortedProjects.sort((a, b) => (b.status || 0) - (a.status || 0));
                break;
            case 'Project Title (A-Z)':
                sortedProjects.sort((a, b) => (a.title || '').localeCompare(b.title || ''));
                break;
            case 'Project Title (Z-A)':
                sortedProjects.sort((a, b) => (b.title || '').localeCompare(a.title || ''));
                break;
        }

        setProjects(sortedProjects);
    }

    return (
        <div className="p-4 max-w-7xl mx-auto">
            {/* Header section */}
            <div className="flex flex-col md:flex-row justify-between md:items-center">
                <h2 className="text-2xl/7 font-bold text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight">Projects</h2>
                <div className="flex flex-row space-x-2 mt-4 md:mt-0">
                    <div className="min-w-36">
                        <OutlinedDropdownMenu
                            options={filterOptions}
                            onSelect={(option) => setActiveFilter(option)}
                            defaultValue={activeFilter}
                        />
                    </div>
                    <div className="min-w-36">
                        <OutlinedDropdownMenu
                            options={sortOptions}
                            onSelect={(option) => setActiveSort(option)}
                            defaultValue={activeSort}
                        />
                    </div>
                    {/* <FilledButton onClick={goToCreateNewProject}>Create New Project</FilledButton> */}
                </div>
            </div>

            {/* Projects section */}
            {projects.length === 0
                ? <div className="mt-10 flex flex-col items-center space-y-4">
                    <img src="https://storage.googleapis.com/public-platform-assets/images/no_data.svg" alt="No projects" />
                    <p className="body1">No projects found</p>
                </div>
                : <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                    {projects.map((project) => (
                        <ProjectCard
                            key={project._id}
                            project={project}
                            className="hover:scale-105 cursor-pointer transition-all duration-300"
                            onClick={() => {
                                goToProjectDetails(project._id!);
                            }}
                        />
                    ))}
                </div>}
            {showCreateProjectLightbox && <EditOrCreateProjectLightbox onClose={() => { setShowCreateProjectLightbox(false) }} />}
        </div >
    );
};




export default EmployerMyProjects;